<template>
  <SidebarSlider :slides="slides" />
</template>

<script>
import SidebarSlider from "../../components/SidebarSlider/SidebarSlider.vue";

export default {
  name: "app",
  components: {
    SidebarSlider
  },
  data() {
    return {
      slides: JSON.parse(this.$options._parentVnode.data.props.slides)
    };
  }
};
</script>
